import React, { createContext, useContext, useMemo, useCallback } from 'react';

// ProductsContext artık sadece memoized selectors içerir
// Veri yönetimi DataContext'te yapılır

interface ProductsContextType {
  // Artık sadece helper/selector fonksiyonları
  formatPrice: (price: number) => string;
  getCategoryDisplayName: (category: string) => string;
}

const ProductsContext = createContext<ProductsContextType | undefined>(undefined);

export const useProducts = () => {
  const context = useContext(ProductsContext);
  if (context === undefined) {
    throw new Error('useProducts must be used within a ProductsProvider');
  }
  return context;
};

export const ProductsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  
  // HELPER FUNCTIONS - memoized
  const formatPrice = useCallback((price: number): string => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    }).format(price);
  }, []);

  const getCategoryDisplayName = useCallback((category: string): string => {
    const categoryNames: Record<string, string> = {
      'damacana': 'Damacana Su',
      'sise': 'Şişe Su',
      'sebil': 'Su Sebili'
    };
    return categoryNames[category] || category;
  }, []);

  const value = useMemo<ProductsContextType>(() => ({
    formatPrice,
    getCategoryDisplayName
  }), [formatPrice, getCategoryDisplayName]);

  return (
    <ProductsContext.Provider value={value}>
      {children}
    </ProductsContext.Provider>
  );
};

